<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title">{{'TITLE.TITLE_SELECT_SKILL' | translate}} ({{StaffName}})</h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
            <!--<div class="row mb-2">
                <div class="col">
                    <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search" name="Keyword" [(ngModel)]="Keyword" (input)="onKeyword($event.target.value)">
                </div>
            </div>-->
        <div class="d-flex mb-2">
            <!--<input class="form-check-input" type="checkbox" id="AllSkill" (change)="SelectAll($event)" [(ngModel)]="AllSkillSelected">-->
            <a class="text-primary" (click)="SelectAll(true)" translate>BTN.BTN_SELECT_ALL</a><span> &nbsp; | &nbsp;</span>
            <a class="text-primary" (click)="SelectAll(false)" translate>BTN.BTN_UNSELECT_ALL</a>
        </div>
        <div class="ModalContainer">
            <div class="row pl-4" *ngFor="let row of SkillList; let index = index;">
                <div class="col form-check">
                    <input class="form-check-input" type="checkbox" [value]="row.Id" (change)="AddSkill($event, index)" [(ngModel)]="row.Selected" [id]="row.Id">
                    <span class="form-check-label">
                        {{row.Name
            }}
            </span>
</div>
            </div>
            </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-primary mr-3" (click)="DisableModalOpenEvent = false;SaveSkill()" translate>BTN.BTN_OK</button>
       <!-- <button class="btn btn-default" (click)="d('dismiss')" translate>BTN.BTN_CANCEL</button>-->
    </div>
</ng-template>
